import React, {useRef} from 'react';
// eslint-disable-next-line import/default
import ReactQuill, {Quill} from 'react-quill-new';

import MagicUrl from 'quill-magic-url';
// eslint-disable-next-line no-restricted-syntax
import 'react-quill-new/dist/quill.snow.css';
import {quillConfig} from 'src/modules/comments/components/html-area/quill-config';
import {MAX_COMMENT_TEXT_LENGTH} from 'src/modules/comments/constants';
import {useQuillLength} from 'src/modules/comments/hooks/useQuillLength';

import {Group} from '@pb/kit-component-group';
import {Typography} from '@pb/kit-component-typography';

import {commentsBlockQuill, commentsBlockQuillDisabled} from '../../comments.module.styl';

Quill.register('modules/magicUrl', MagicUrl);

type Props = {
    changeRequestId: number | null,
    currentComment: string,
    onChange: (value: string) => void,
    onHtmlLengthChange: (length: number) => void,
    onTextLengthChange: (length: number) => void,
};

export const HtmlArea = (props: Props) => {
    const {
        changeRequestId,
        currentComment,
        onChange,
        onHtmlLengthChange,
        onTextLengthChange,
    } = props;

    const quillRef = useRef<ReactQuill>(null);
    const textLength = useQuillLength(quillRef, onHtmlLengthChange, onTextLengthChange);

    return (
        <>
            <ReactQuill
                ref={quillRef}
                className={`${commentsBlockQuill} ${!changeRequestId && commentsBlockQuillDisabled}`}
                placeholder="Add a сomment"
                theme="snow"
                value={currentComment}
                onChange={onChange}
                modules={quillConfig}
                readOnly={!changeRequestId}
            />
            <Group justify="flex-end">
                <Typography variant="body-level-4">{`${textLength} / ${MAX_COMMENT_TEXT_LENGTH}`}</Typography>
            </Group>
        </>
    );
};
